import { ChangeDetectorRef, Component } from '@angular/core'
import { GlobalMessageType, RoutingService } from '@spartacus/core'
import { finalize } from 'rxjs/operators'
import { CustomRoutes } from '../../../../../models/enum/custom-routes.enum'
import { ICsv } from '../../../../../models/interface/csv.interface'
import { ISharedPagination } from '../../../../../models/interface/shared.interface'
import { ShipmentCreditClaim } from '../../../../../models/shipment-credit-claim'
import { ShipmentCreditClaimService } from '../../../../../services/agreement/shipment-credit-claim/shipment-credit-claim.service'
import { RebateClaimService } from '../../../../../services/rebate-claims/rebate-claim.service'
import { CsvService } from '../../../../../services/shared/csv/csv.service'
import { CustomGlobalMessageService } from '../../../../../services/shared/custom-global-message/custom-global-message.service'
import { SharedService } from '../../../../../services/shared/shared.service'
import { CustomTableColumnType } from '../../../../shared/custom-components/custom-table/modals/enum/custom-table.enum'
import { RebateClaimsHistoryComponent } from '../../../rebate-claims/rebate-claims-history/rebate-claims-history.component'

@Component({
    selector: 'app-shipment-credit-claims',
    templateUrl: './shipment-credit-claims.component.html',
    styleUrls: ['./shipment-credit-claims.component.scss'],
    standalone: false
})
export class ShipmentCreditClaimsComponent extends RebateClaimsHistoryComponent {
  public shipmentCreditClaims: ShipmentCreditClaim
  // public selectedSort: string;
  public selectedFilter: string
  public selectedPage = 1
  public downloadingCsv = false
  public selectedSearch: string
  public agreementCode: string
  public inputSearch: string

  constructor(
    routingService: RoutingService,
    rebateClaimService: RebateClaimService,
    globalMessageService: CustomGlobalMessageService,
    changeDetectorRef: ChangeDetectorRef,
    csvService: CsvService,
    sharedService: SharedService,
    public shipmentCreditClaimService: ShipmentCreditClaimService
  ) {
    super(routingService, rebateClaimService, globalMessageService, changeDetectorRef, csvService, sharedService)
  }

  ngOnInit() {
    this.options = [{ label: 'shared.sort.byDateCreated', value: 'creationtime:desc' }]

    this.headers = [
      { title: 'shipmentCreditClaim.dispenserCreditId' },
      { title: 'shipmentCreditClaim.dateCreated' },
      { title: 'shipmentCreditClaim.creditRequestMethod' },
      { title: 'shared.value' },
      { title: 'shared.status' },
      { title: 'shared.actions', type: CustomTableColumnType.BUTTONS }
    ]

    this.columns = [
      { key: 'id', type: CustomTableColumnType.LINK, link: { handler: (res) => this.viewDetails(res) } },
      { key: 'dateCreated', type: CustomTableColumnType.DATE },
      { key: 'creditRequestMethod' },
      { key: 'value' },
      {
        key: 'status',
        type: CustomTableColumnType.UPDATE_BUTTON,
        button: {
          icon: 'fas fa-sync',
          handler: (res) => this.refreshPageData(res)
        }
      },
      {
        key: 'actions',
        type: CustomTableColumnType.BUTTONS,
        buttons: [
          {
            title: 'shared.details',
            translate: true,
            handler: (res) => this.viewDetails(res),
            icon: 'fa fa-info-circle'
          }
        ]
      }
    ]

    super.ngOnInit()
  }

  pageChange(page: number): void {
    // TODO:Spartacus - 'RoutingService.go' changed signature. Before 4.0, the object with query params could be passed in the 2nd argument. Now the 2nd argument is Angular NavigationExtras object (with 'queryParams' property).
    this.routingService.go(
      {
        cxRoute: CustomRoutes.SHIPMENT_CREDIT_CLAIM
        // Sagar
        // }, null, {queryParams: {page: page}});
      },
      { queryParams: { page: page } }
    )

    this.selectedPage = page
    this.changePageData({
      pageNumber: page,
      sort: this.selectedSort
    })
  }

  changePageData(params: ISharedPagination) {
    this.showLoaderOnPagination = true
    this.shipmentCreditClaimService
      .getShipmentCreditClaim(params)
      .pipe(
        finalize(() => {
          this.showLoaderOnPagination = false
          this.changeDetectorRef.detectChanges()
        })
      )
      .subscribe(
        (res) => {
          this.shipmentCreditClaims = res
        },
        (err) => {
          this.globalMessageService.add(err.message, GlobalMessageType.MSG_TYPE_ERROR)
        }
      )
  }

  viewDetails(value: any) {
    const queryParam = {
      [CustomRoutes.SHIPMENT_CREDIT_CLAIM]: { page: this.selectedPage }
    }
    this.sharedService.setQueryParamsLocal(queryParam)

    // TODO:Spartacus - 'RoutingService.go' changed signature. Before 4.0, the object with query params could be passed in the 2nd argument. Now the 2nd argument is Angular NavigationExtras object (with 'queryParams' property).
    this.routingService.go({
      cxRoute: CustomRoutes.SHIPMENT_CREDIT_CLAIM_HISTORY,
      params: { code: value?.id }
    })
  }

  get showLoaderOnStartupOrWhenNoData(): boolean {
    return !this.shipmentCreditClaims?.results?.length && this.showLoaderOnPagination
  }

  public refreshPageData(value: any): void {
    this.showLoaderOnPagination = true
    this.shipmentCreditClaimService
      .getShipmentCreditClaimById(value.id)
      .pipe(
        finalize(() => {
          this.showLoaderOnPagination = false
          this.changeDetectorRef.detectChanges()
        })
      )
      .subscribe(
        (res) => {
          this.shipmentCreditClaims.results = this.shipmentCreditClaims.results.map((item) => {
            if (item.id != res.id) {
              return item
            }
            return res
          })
        },
        (err) => {
          this.globalMessageService.add(err.message, GlobalMessageType.MSG_TYPE_ERROR)
        }
      )
  }

  public SearchById(value): void {
    if (value == null || value == undefined) {
      this.changePageData({
        pageNumber: 0,
        sort: this.selectedSort
      })
    } else {
      this.selectedSearch = value?.trim()
      this.showLoaderOnPagination = true
      this.shipmentCreditClaimService
        .getShipmentCreditClaimByAgreementId(this.selectedSearch)
        .pipe(
          finalize(() => {
            this.showLoaderOnPagination = false
            this.changeDetectorRef.detectChanges()
          })
        )
        .subscribe(
          (res) => {
            this.shipmentCreditClaims = res
          },
          (err) => {
            this.shipmentCreditClaims = null
            this.showLoaderOnPagination = false
            this.changeDetectorRef.detectChanges()
          }
        )
    }
  }
  public SearchByMemoId(value): void {
    if (value == null || value == undefined) {
      this.changePageData({
        pageNumber: 0,
        sort: this.selectedSort
      })
    } else {
      this.selectedSearch = value?.trim()
      this.showLoaderOnPagination = true
      this.shipmentCreditClaimService
        .getShipmentCreditClaimByMemoId(this.selectedSearch)
        .pipe(
          finalize(() => {
            this.showLoaderOnPagination = false
            this.changeDetectorRef.detectChanges()
          })
        )
        .subscribe(
          (res) => {
            this.shipmentCreditClaims = res
          },
          (err) => {
            this.shipmentCreditClaims = null
            this.showLoaderOnPagination = false
            this.changeDetectorRef.detectChanges()
          }
        )
    }
  }
  public downloadCSV(): void {
    this.downloadingCsv = true

    this.shipmentCreditClaimService
      .getShipmentCreditClaim({
        pageNumber: 0,
        pageSize: 200,
        sort: this.selectedSort
      })
      .subscribe((res) => {
        const csv: ICsv = {
          title: `Credit History`,
          columns: [
            { title: 'dispenserShipment.id', key: 'code' },
            { title: 'dispenserShipment.creditMemo', key: 'documentNumber' },
            { title: 'dispenserShipment.agreementNumber', key: 'quote.orderCode' },
            { title: 'dispenserShipment.date', key: 'shipmentOrderDate', type: CustomTableColumnType.DATE },
            { title: 'dispenserShipment.type', key: 'type' },
            { title: 'shared.status', key: 'status' },
            { title: 'dispenserShipment.netValue', key: 'netValue.formattedValue' },
            { title: 'dispenserShipment.gst', key: 'gst.formattedValue' },
            { title: 'dispenserShipment.invoice', key: 'invoice' }
          ],
          rows: this.extractEntries(res)
        }
        this.downloadingCsv = false
        this.csvService.generateCSV(csv)
        this.changeDetectorRef.detectChanges()
      })
  }
  protected extractEntries(res): any[] {
    const newItems = []

    for (const entry of res?.results) {
      for (const item of entry?.entries) {
        if (item.orderDocumentsNumber?.length) {
          const documentNumber = item.orderDocumentsNumber
          if (documentNumber?.length) {
            item.documentNumber = this.getOrderDocumentNumber(documentNumber)
          }
        }
        newItems.push(item)
      }
    }

    return newItems
  }
  public get disableWhenNoDataOrDownloading(): boolean {
    return !this.shipmentCreditClaims?.results?.length || this.downloadingCsv
  }

  private getOrderDocumentNumber(str): any {
    if (str?.length) {
      return str[0].documentNumber
    }
    return ' '
  }
}
